// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2UAI0","header":"ClearentDisclaimer_header__1bRCi","inner":"ClearentDisclaimer_inner__2XpH5"};